import { builderX } from '@gongxigames/framework/core/fragments/BuilderX';
import loader from './loader';
import sprites from './sprites';
import resourcesToLoad from './resourcesToLoad';
import bigWinParticles from './bigWinParticles';
import bigWinParticlesNonAsian from './bigWinParticlesNonAsian';
import waitingPopup from './waitingPopup';
import spineAttachments from './spineAttachments';

import bottomBar_desktop from './desktop/bottomBar';
import buyBonus_bottomBar_desktop from './desktop/buyBonus_bottomBar';
import bottomPanel_desktop from './desktop/bottomPanel';
import clock_desktop from './desktop/clock';
import totalBetDesktop from './desktop/totalBet';
import cashDesktop from './desktop/cash';
import winDesktop from './desktop/win';
import waterMark_desktop from './desktop/waterMark_desktop';

import bottomBar_mobile from './mobile/bottomBar';
import buyBonus_bottomBar_mobile from './mobile/buyBonus_bottomBar';
import bottomBar_portrait_mobile from './mobile/bottomBar_portrait';
import buyBonus_bottomBar_portrait_mobile from './mobile/buyBonus_bottomBar_portrait';
import soundBar_mobile from './mobile/soundBar';
import soundBar_portrait_mobile from './mobile/soundBar_portrait';
import balanceBar_mobile from './mobile/balanceBar';
import balanceBar_portrait_mobile from './mobile/balanceBar_portrait';
import menuBar_mobile from './mobile/menuBar';
import menuBar_portrait_mobile from './mobile/menuBar_portrait';
import resources_mobile from './mobile/resources';
import clock_mobile from './mobile/clock';
import clock_pm_mobile from './mobile/clock_pm';
import totalBetMobile from './mobile/totalBet';
import cashMobile from './mobile/cash';
import winMobile from './mobile/win';
import waterMark_portrait from './mobile/waterMark_portrait';
import waterMark_landscape from './mobile/waterMark_landscape';
import buyFeature from '@gongxigames/framework/slot/configs/scenes/buyFeature';

builderX.register('loader', loader, 'shared', 'shared_sprite');
builderX.register('sprites', sprites, 'shared', 'shared_sprite');
builderX.register('resourcesToLoad', resourcesToLoad, 'shared', 'shared_sprite');
builderX.register('bigWinParticles', bigWinParticles, 'shared', 'shared_sprite');
builderX.register('bigWinParticlesNonAsian', bigWinParticlesNonAsian, 'shared', 'shared_sprite');
builderX.register('waitingPopup', waitingPopup, 'shared', 'shared_sprite');
builderX.register('spineAttachments', spineAttachments, 'shared', 'shared_sprite');
builderX.register('buyFeature', buyFeature, 'shared', 'shared_sprite');

builderX.register('totalBet', totalBetDesktop, 'desktop', 'shared_sprite');
builderX.register('cash', cashDesktop, 'desktop', 'shared_sprite');
builderX.register('win', winDesktop, 'desktop', 'shared_sprite');
builderX.register('bottomBar', bottomBar_desktop, 'desktop', 'shared_sprite');
builderX.register('buyBonus_bottomBar', buyBonus_bottomBar_desktop, 'desktop', 'shared_sprite');
builderX.register('bottomPanel', bottomPanel_desktop, 'desktop', 'shared_sprite');
builderX.register('clock', clock_desktop, 'desktop', 'shared_sprite');
builderX.register('waterMark_desktop', waterMark_desktop, 'desktop', 'shared_sprite');

builderX.register('totalBet', totalBetMobile, 'mobile', 'shared_sprite');
builderX.register('cash', cashMobile, 'mobile', 'shared_sprite');
builderX.register('win', winMobile, 'mobile', 'shared_sprite');
builderX.register('bottomBar', bottomBar_mobile, 'mobile', 'shared_sprite');
builderX.register('buyBonus_bottomBar', buyBonus_bottomBar_mobile, 'mobile', 'shared_sprite');
builderX.register('bottomBar_portrait', bottomBar_portrait_mobile, 'mobile', 'shared_sprite');
builderX.register('buyBonus_bottomBar_portrait', buyBonus_bottomBar_portrait_mobile, 'mobile', 'shared_sprite');
builderX.register('soundBar', soundBar_mobile, 'mobile', 'shared_sprite');
builderX.register('soundBar_portrait', soundBar_portrait_mobile, 'mobile', 'shared_sprite');
builderX.register('balanceBar', balanceBar_mobile, 'mobile', 'shared_sprite');
builderX.register('balanceBar_portrait', balanceBar_portrait_mobile, 'mobile', 'shared_sprite');
builderX.register('menuBar', menuBar_mobile, 'mobile', 'shared_sprite');
builderX.register('menuBar_portrait', menuBar_portrait_mobile, 'mobile', 'shared_sprite');
builderX.register('waterMark_portrait', waterMark_portrait, 'mobile', 'shared_sprite');
builderX.register('waterMark_landscape', waterMark_landscape, 'mobile', 'shared_sprite');
builderX.register('resources', resources_mobile, 'mobile', 'shared_sprite');
builderX.register('clock', clock_mobile, 'mobile', 'shared_sprite');
builderX.register('clock_pm', clock_pm_mobile, 'mobile', 'shared_sprite');
